import { Grid, MenuItem } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import {
  getBusinesses,
  getBusinessesDomainsBySectors,
  getBusinessExternalByIndividual,
  getBusinessExternalBySchool,
  getContractTypes,
  getDegreeLevels,
} from '@webapps/business';
import {
  Button,
  FormikAutocomplete50,
  FormikAutocompletePx,
  FormikTextField,
  TextField,
  TextField50P,
  TextFieldPx,
  useAuth,
  useQuery,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';

const TELETRAVAIL = [
  {
    label: 'Présentiel',
  },
  {
    label: 'Distanciel',
  },
  {
    label: 'Présentiel et Distanciel',
  },
];

// eslint-disable-next-line react/prop-types
const FiltersEmploi = ({
  formik = {},
  resetParamsUrl,
  handleClose,
  domains,
  domainLoading,
}) => {
  const {
    classes,
    css,
    cx,
    theme: { spacing },
  } = useStyles(styles);
  const [domainId, setDomainId] = useState();

  const { profile, idUser } = useAuth();

  const {
    data: { content: businesses = [] } = {},
    isLoading: businessLoading,
  } = useQuery(getBusinesses, {
    key: 'allBusinessMap',
  });

  // const { data: sectors = [], isLoading: sectorLoading } = useQuery(
  //   getBusinessesSectors,
  //   {
  //     key: 'allSectorsJobs',
  //   }
  // );

  const { data: sectors = [], isLoading: sectorLoading, refetch } = useQuery(
    getBusinessesDomainsBySectors,
    {
      key: ['sectorByDomain', domainId],
      variables: { id: domainId || formik?.values?.domains },
    }
  );

  const { data: degreeLevels = [], isLoading: degreeLevelLoading } = useQuery(
    getDegreeLevels,
    {
      key: 'levels',
    }
  );

  const { data: contractTypes = [], isLoading: contratTypLoading } = useQuery(
    getContractTypes,
    {
      key: 'contractTypes',
    }
  );

  const { data: businessExternal = [], isLoading: businessExternalLoading } = useQuery(profile === "INDIVIDUAL" ? getBusinessExternalByIndividual : getBusinessExternalBySchool,
    {
      key: 'businessExternal',
      variables: { id: idUser },
      enabled: profile !== "BUSINESS",
    }
  );

  const resetFilter = () => {
    resetParamsUrl();
    formik.resetForm();
    formik.handleSubmit();
  };

  useEffect(() => {
    refetch();
  }, [formik?.values?.domains]);

  return (
    <Grid container>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.name || ''}
          label={<FormattedMessage id="map.businesses" />}
          loading={businessLoading}
          loadingText={
            <>
              <FormattedMessage id="loading" />
              ...
            </>
          }
          multiple
          name="businesses"
          options={businesses}
          pathValue="id"
          value={businesses.filter(({ id }) =>
            formik?.values?.businesses?.includes(id)
          )}
        />
      </Grid>
      {profile !== "BUSINESS" &&
        <Grid className={classes.grid} item xs={12}>
          <FormikAutocompletePx
            formik={formik}
            fullWidth
            borderRadius={6}
            getOptionLabel={(option) => option.name || ''}
            label="Entreprises externes"
            loading={businessExternalLoading}
            loadingText={
              <>
                <FormattedMessage id="loading" />
                ...
              </>
            }
            multiple
            name="businessesExternals"
            options={businessExternal}
            pathValue="id"
            value={businessExternal.filter(({ id }) =>
              formik?.values?.businessesExternals?.includes(id)
            )}
          />
        </Grid>
      }
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.label || ''}
          label="Domaines pro."
          name="domains"
          options={domains}
          pathValue="id"
          value={domains.find((domain) => domain.id === formik.values.domains) || null}
          // popupIcon={<MenuBookRounded style={{ color: '#5D75A8' }} />}
        />
      </Grid>
      {sectors[0] && (
        <Grid
          className={cx(
            classes.grid,
            css({ display: 'flex', justifyContent: 'flex-end' })
          )}
          item
          xs={12}
        >
          <Grid className={css({})} item xs={12}>
            <FormikAutocompletePx
              formik={formik}
              fullWidth
              borderRadius={6}
              getOptionLabel={(option) => option.label || ''}
              label="Secteur(s) de métier(s)"
              loading={sectorLoading}
              loadingText={
                <>
                  <FormattedMessage id="loading" />
                  ...
                </>
              }
              multiple
              name="sectors"
              // onChange={handleChangeSectors}
              options={sectors}
              pathValue="id"
              value={sectors?.filter(({ id }) =>
                formik?.values?.sectors?.includes(id)
              )}
            />
          </Grid>
        </Grid>
      )}
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.label || ''}
          label="Niveau(x) d'étude(s)"
          loading={degreeLevelLoading}
          loadingText={
            <>
              <FormattedMessage id="loading" />
              ...
            </>
          }
          multiple
          name="degreeLevels"
          options={degreeLevels}
          pathValue="id"
          value={degreeLevels.filter(({ id }) =>
            formik.values.degreeLevels.includes(id)
          )}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.label || ''}
          label="Type(s) de contrat(s)"
          loading={contratTypLoading}
          loadingText={
            <>
              <FormattedMessage id="loading" />
              ...
            </>
          }
          multiple
          name="contractTypes"
          options={contractTypes}
          pathValue="id"
          value={contractTypes.filter(({ id }) =>
            formik.values.contractTypes.includes(id)
          )}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <FormikAutocompletePx
          formik={formik}
          fullWidth
          borderRadius={6}
          getOptionLabel={(option) => option.label || ''}
          label="Présence"
          loading={contratTypLoading}
          loadingText={
            <>
              <FormattedMessage id="loading" />
              ...
            </>
          }
          multiple
          name="telework"
          options={TELETRAVAIL}
          pathValue="label"
          value={TELETRAVAIL.filter(({ label }) =>
            formik.values.telework.includes(label)
          )}
        />
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <Button
          color="primary"
          fullWidth
          onClick={() => {
            handleClose();
            formik.handleSubmit();
          }}
          variant="contained"
        >
          <FormattedMessage id="btnSearch" />
        </Button>
      </Grid>
      <Grid className={classes.grid} item xs={12}>
        <Button
          className={css({ backgroundColor: 'white' })}
          color="primary"
          fullWidth
          onClick={resetFilter}
          variant="outlined"
        >
          Réinitialiser
        </Button>
      </Grid>
    </Grid>
  );
};

const styles = ({ spacing }) => ({
  grid: {
    marginTop: spacing(2),
  },
});

export default FiltersEmploi;
